import { render, staticRenderFns } from "./FormEditFooter.vue?vue&type=template&id=247f7047"
import script from "./FormEditFooter.vue?vue&type=script&lang=ts"
export * from "./FormEditFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports